import EmptyPlaceholder from "common/components/EmptyPlaceholder";

import ExcludedLeadsImage from "assets/images/empty-placeholders/blacklist-new.png";
import IncludedLeadsImage from "assets/images/empty-placeholders/lead-list-no-leads.png";

const PLACEHOLDERS = {
  included: {
    title: "No leads yet",
    subtitle: "Leads collected from this list's sources will show up here",
    imageSrc: IncludedLeadsImage,
  },
  excluded: {
    title: "No excluded leads",
    subtitle: "You haven't removed or blacklisted any leads yet",
    imageSrc: ExcludedLeadsImage,
  },
} as const;

export default function NoLeadsPlaceholder({
  type,
}: {
  type: "included" | "excluded";
}) {
  const { title, subtitle, imageSrc } = PLACEHOLDERS[type];

  return (
    <EmptyPlaceholder
      className="py-20"
      title={title}
      subtitle={subtitle}
      imageSrc={imageSrc}
    />
  );
}
